import {css, StyleSheet} from 'aphrodite';
import React, {useState} from 'react';

import {CLICKABLE} from 'analyses/alignment/modals/StyleConstants';
import getTestProps from 'test/lib/cypress/getTestProps';
import Button, {ButtonStyle, ButtonSize} from 'ui-library/buttons/Button';
import {GRAY_DARK, WHITE} from 'ui-library/Colors';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import Tooltip from 'ui-library/floating-ui/Tooltip';

import {DocumentHistoryPanel} from './DocumentHistoryPanel';

export interface DocumentHistoryButtonProps {
  documentId: string;
  title: string;
  tooltipText: string;
  buttonClassName?: string;
}

export function DocumentHistoryButton({
  documentId,
  buttonClassName,
  title,
  tooltipText,
}: DocumentHistoryButtonProps): JSX.Element {
  const [isOpen, setIsOpen] = useState(false);
  const handleOpenAndClicked = (): void => {
    setIsOpen(!isOpen);
  };

  const historyPanelMenu = (
    <div className={css(styles.newHistoryPanelMenu)}>
      <DocumentHistoryPanel
        id={documentId}
        title={title}
        {...getTestProps({component: 'DocumentHistoryPanel', element: 'component'})}
      />
    </div>
  );

  return (
    <Dropdown
      isOpen={isOpen}
      onToggle={handleOpenAndClicked}
      closeOnInsideClick={false}
      closeOnOutsideClick={true}
      menu={historyPanelMenu}
    >
      <div className={css(styles.buttonWrapper)}>
        <Tooltip placement={FloatingPlacement.TOP} text={tooltipText}>
          <Button
            className={buttonClassName}
            buttonStyle={isOpen ? ButtonStyle.TERTIARY_BLUE_POWDER : ButtonStyle.TERTIARY_GRAY}
            size={ButtonSize.MEDIUM}
            icon="clock-outline"
            dataTestAttrs={{component: 'HistoryButton', element: 'button'}}
          />
        </Tooltip>
      </div>
    </Dropdown>
  );
}

export const styles = StyleSheet.create({
  buttonWrapper: {
    marginRight: '8px',
  },
  menu: {
    backgroundColor: WHITE,
    borderRadius: 4,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)',
    marginTop: 3,
    padding: 14,
    position: 'absolute',
    zIndex: 1000, // Keep in sync with zindex-dropdown in `less/bootstrap/variables.less`
    minWidth: '365px',
    top: '40px',
    right: '-100px',
    overflow: 'scroll',
  },
  crossIcon: {color: GRAY_DARK},
  crossIconContainer: {...CLICKABLE, alignSelf: 'center'},
  historyPanelHeader: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  historyTitle: {
    fontSize: '12px',
    fontWeight: 600,
    alignSelf: 'center',
  },
  newHistoryPanelMenu: {
    backgroundColor: WHITE,
    borderRadius: 4,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)',
    marginTop: 3,
    position: 'absolute',
    zIndex: 1000,
    minWidth: '260px',
    top: '40px',
    height: '60vh',
    right: -100,
  },
});
